import { z } from 'zod';
export const AudienceSessionWidgetKey = 'audience-session-widget:v1';
export const AudienceSessionWidgetKind = 'audience_session';
export const AUDIENCE_SESSION_ARTIFACT_KEY_PREFIX = 'audience-session:';
const TranscriptMessageSchema = z.object({
    role: z.enum(['user', 'assistant', 'system', 'tool']),
    content: z.string(),
    speakerName: z.string().nullable().optional(),
    personaId: z.string().nullable().optional(),
    agentId: z.string().nullable().optional(),
    createdAt: z.string(),
    isHandoff: z.boolean().optional(),
});
const SessionPersonaSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
});
// Unlike the focus-group artifact (which keeps a live-read preview against
// persona-api), the audience session preview reads this snapshot directly:
// reconstructing a chat from contextId would require refetching every exchange
// + resolving each persona on every preview open, and the underlying chat
// session can be deleted/expired without warning. Keeping the transcript
// inline is the resilient path.
export const AudienceSessionWidgetSchema = z.object({
    contextId: z.string(),
    title: z.string(),
    personas: z.array(SessionPersonaSchema),
    messages: z.array(TranscriptMessageSchema),
    startedAt: z.string(),
    lastMessageAt: z.string().nullable(),
});
